// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2019":"d6209356c5b5d1c3","2740":"db71e5d908516857","2957":"ead57005e6062837"}[chunkId] + ".css";
};